/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "bills": {
            "nested": {
              "ClientDetails": {
                "fields": {
                  "deviceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "appVersion": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "writeOnlyRevenueShare": {
                    "type": ".squareup.client.bills.ClientDetails.RevenueShare",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "RevenueShare": {
                    "fields": {
                      "integrationId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "merchantToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ClientDetails && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.ClientDetails?.nested?.RevenueShare) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ClientDetails @ squareup/client/bills/client_details.proto at 10:1
 */
export const ClientDetails = $root.lookupType('squareup.client.bills.ClientDetails');
fixType(ClientDetails);
Builder.createAndAttachToType(ClientDetails);
/**
 * SOURCE RevenueShare @ squareup/client/bills/client_details.proto at 19:3
 */
ClientDetails.RevenueShare = $root.lookupType('squareup.client.bills.ClientDetails.RevenueShare');
fixType(ClientDetails.RevenueShare);
Builder.createAndAttachToType(ClientDetails.RevenueShare);